/* eslint-disable max-len */
import { Card, Col, Row } from 'antd';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';

import { ECrsStav, ICrsHistorie, crsHistorieGet, crsZruseni } from 'services/poDlt/crs';

import { ENotificationType } from 'enums/notificationType';
import routePathEnum from 'enums/routePathEnum';

interface ICrsPrehled {}

const CrsPrehled: React.FC<ICrsPrehled> = () => {
    const { navigateWorkaround } = useNavigateWorkaround();
    const { aktivniFirma, NotificationComponent } = useContext(Context);
    const [prehled, setPrehled] = useState<ICrsHistorie>();
    const [errStatus, setErrStatus] = useState<number>();
    const [loading, setLoading] = useState<boolean>(false);
    const [refetchData, setRefetchData] = useState<boolean>(false);

    useEffect(() => {
        setLoading(true);
        setErrStatus(0);

        crsHistorieGet({
            offset: 0,
            order: 'id:desc',
            limit: 1
        })
            .then(resp => {
                setPrehled(resp);
            })
            .catch((err: any) => {
                setErrStatus(err.response?.status);
            })
            .finally(() => setLoading(false));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refetchData]);

    return (
        <LoadingWrapper
            loading={loading}
            style={{
                paddingTop: '100px'
            }}
        >
            {errStatus ? (
                <Row
                    justify="center"
                    align="middle"
                    style={{
                        height: '100%'
                    }}
                >
                    <Col span={16} flex={'0 0 auto'}>
                        {errStatus === 404 ? (
                            <Title text="DOTAZNIK_CRS_404" level={3} />
                        ) : errStatus ? (
                            <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                        ) : null}
                    </Col>
                </Row>
            ) : (
                <>
                    {' '}
                    <Row gutter={16}>
                        <Col
                            span={12}
                            style={{
                                marginBottom: 36
                            }}
                        >
                            <Title text="DOTAZNIK_CRS" level={4} />
                            <Card
                                className="dash-card"
                                title={''}
                                style={{
                                    height: 'fit-content'
                                }}
                            >
                                {prehled?.dotaznik?.datum && (
                                    <>
                                        <Title text="EMP_PODANE_ZADOSTI_DATUM_PODANI" level={5} />
                                        <p>{dayjs(prehled?.dotaznik?.datum).format('DD.MM.YYYY')}</p>
                                    </>
                                )}
                                {prehled?.dotaznik?.stav && (
                                    <>
                                        <Title text="EMP_PODANE_ZADOSTI_STAV" level={5} />

                                        <p>
                                            <TranslateText>{`CRS_STAV_${prehled?.dotaznik?.stav}`}</TranslateText>
                                        </p>
                                    </>
                                )}

                                <Row className="button-row">
                                    {prehled?.dotaznik?.stav === ECrsStav.ROZP && (
                                        <>
                                            <ButtonComponent
                                                buttontext={'POKRACOVAT'}
                                                id="crsPrehledPokracovatBtn"
                                                onClick={() => {
                                                    navigateWorkaround(
                                                        `/firma/${aktivniFirma?.iducet}/${routePathEnum.CRS_DOTAZNIK_NOVY.split('/')[1]}/${prehled.dotaznik?.iddot}`
                                                    );
                                                }}
                                            />

                                            <ButtonComponent
                                                id="crsPrehledZrusitZadostBtn"
                                                buttontext={'ZRUSIT_ZADOST'}
                                                onClick={() => {
                                                    setLoading(true);
                                                    crsZruseni(prehled?.dotaznik?.iddot).then(() => {
                                                        NotificationComponent({
                                                            title: 'ZRUSIT_ZADOST',
                                                            description: 'ZRUSIT_ZADOST_SUCCESS',
                                                            type: ENotificationType.SUCCESS
                                                        });
                                                        setRefetchData(pv => !pv);
                                                    });
                                                }}
                                            />
                                        </>
                                    )}

                                    {/* prehled?.dotaznik?.stav === ECrsStav.ZPRAC && (
                                        <ButtonComponent
                                            buttontext={'STAHNOUT_PDF'}
                                            onClick={() => {
                                                setLoading(true);
                                                crsPDFdownload(
                                                    prehled.dotaznik?.iddot,
                                                    `${getLanguageObject(language).DOTAZNIK_CRS}${dayjs(prehled?.dotaznik?.datum).format('DD.MM.YYYY')}.pdf`
                                                ).finally(() => setLoading(false));
                                            }}
                                            id="crsPrehledVyjadreniBtn"
                                        />
                                    ) */}
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                </>
            )}
        </LoadingWrapper>
    );
};

export default CrsPrehled;
